const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");

const FunnelHealthActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

FunnelHealthActions.fetchData.listen(function(users, funnel) {
  let params = {
    users: users,
    funnel: funnel
  };

  biAPI.fetch("/funnel_health", params, this.completed, this.failed);
});

module.exports = FunnelHealthActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/funnel-health-actions.js